<template>
  <LoaderCar v-if="loading" width="600px" marginTop="0"/>
  <div class="home-desktop-eleve" v-else>
    <div class="formBtn">
      <div class="formulaire" v-if="this.dossier.contrat == false">
        <p id="txtForm">
          Merci de compléter le formulaire. Vous pourrez ensuite accéder aux
          fonctionnalités ci-dessous !
        </p>
        <button class="buttonShin mt-2" @click="goToForm()">
          FORMULAIRE
        </button>
      </div>
    </div>
    <div class="home-eleve">
      <div class="greeting-header">
        <div>
          <h1>Bonjour {{this.$store.state.user.prenom}} !</h1>
          <p class="subtitle">Voici le suivi de votre permis de conduite</p>
        </div>
        <button class="btn-stagecode" v-if="showStageCodeButton" @click="goToStageCode">
          <svg width="18" height="18" fill="none" viewBox="0 0 24 24"><rect x="4" y="4" width="16" height="16" rx="2" stroke="currentColor" stroke-width="1.8"/><path d="M8 12h8M8 8h5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>
          Stage de code
        </button>
      </div>

      <div class="grid">
        <!-- Dossier -->
        <div class="card" @click="goToDossier">
          <div class="card-header-eleve">
            <span>📁 Dossier</span>
            <span class="badge grey" v-if="devDossier">En développement</span>
            <span class="badge badge-dossier" v-else>{{dossier.status.toUpperCase()}}</span>
          </div>

          <div class="progress">
            <div class="progress-bar grey" v-if="devDossier" style="width: 0%"></div>
            <div class="progress-bar bar-dossier" v-else></div>
          </div>

          <div class="card-footer-eleve">
            <template v-if="devDossier">
              <span>En développement</span>
              <span>0 %</span>
            </template>
            <template v-else>
              <span :class="dossier.neph ? 'text-green' : 'text-red'">{{ dossier.info }}</span>
              <span>{{ dossier.pourcent }}</span>
            </template>
          </div>
          <p class="link" v-if="!devDossier && (dossier.status !== 'Enregistrer' && dossier.neph == null || dossier.neph == '')" @click="goToDossier">Accéder au dossier</p>
        </div>

        <!-- Code -->
        <div class="card" @click="goToCode()">
          <div class="card-header-eleve">
            <span>🧾 Code</span>
            <span class="badge grey" v-if="devCode">En développement</span>
            <span class="badge badge-code" v-else>{{this.code.status}}</span>
          </div>

          <div class="progress">
            <div class="progress-bar grey" v-if="devCode" style="width: 0%"></div>
            <div class="progress-bar bar-code" v-else></div>
          </div>

          <div class="card-footer-eleve">
            <template v-if="devCode">
              <span>En développement</span>
              <span>0 %</span>
            </template>
            <template v-else>
              <span>{{code.info}}</span>
              <span>{{code.pourcent}}</span>
            </template>
          </div>

          <p class="link" v-if="!devCode" @click="goToCode()">Accéder au code</p>
        </div>

        <!-- Conduite -->
        <div class="card" @click="goToConduite">
          <div class="card-header-eleve">
            <span>🚗 Conduite</span>
            <span class="badge grey" v-if="devConduite">En développement</span>
            <span class="badge badge-conduite" v-else>{{conduite.status}}</span>
          </div>

          <div class="progress">
            <div class="progress-bar grey" v-if="devConduite" style="width: 0%"></div>
            <div class="progress-bar bar-conduite" v-else></div>
          </div>

          <div class="card-footer-eleve">
            <template v-if="devConduite">
              <span>En développement</span>
              <span>0 %</span>
            </template>
            <template v-else>
              <span>{{conduite.pourcent.info}}</span>
              <span>{{conduite.pourcent.niveau}} %</span>
            </template>
          </div>
          <p class="link" v-if="!devConduite" @click="goToConduite">Consulter mon planning</p>
        </div>

        <!-- Edition -->
        <div class="card" @click="openDevDialog('Edition de votre permis')" style="cursor:pointer">
          <div class="card-header-eleve">
            <span>🪪 Edition de votre permis</span>
            <span class="badge grey">En développement</span>
          </div>

          <div class="progress">
            <div class="progress-bar grey" style="width: 0%"></div>
          </div>

          <div class="card-footer-eleve">
            <span>En développement</span>
            <span>0 %</span>
          </div>
        </div>
      </div>

      <Dialog
        v-model:visible="showDevDialog"
        modal
        :showHeader="false"
        :style="{ width: '460px', maxWidth: '95vw' }"
        :breakpoints="{ '575px': '95vw' }"
      >
        <div class="form-dialog">
          <div class="form-dialog__icon" style="background:#f1f5f9; color:#64748b;">
            <svg width="28" height="28" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/><path d="M12 8v4M12 16h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
          </div>
          <h3 class="form-dialog__title">{{ devFeatureLabel }}</h3>
          <p class="form-dialog__desc">Cette fonctionnalité est encore en développement et sera bientôt disponible. Merci de votre patience !</p>
          <div class="form-dialog__actions">
            <button @click="showDevDialog = false" class="form-dialog__btn">Fermer</button>
          </div>
        </div>
      </Dialog>

      <Dialog
        v-model:visible="showPopupForm"
        modal
        :showHeader="false"
        :style="{ width: '480px', maxWidth: '95vw' }"
        :breakpoints="{ '575px': '95vw' }"
      >
        <div class="form-dialog">
          <div class="form-dialog__icon">
            <svg width="28" height="28" fill="none" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
          <h3 class="form-dialog__title">Formulaire de dossier</h3>
          <p class="form-dialog__desc">Merci de remplir le formulaire d'inscription, vous pourrez ensuite accéder à toutes les fonctionnalités du site.</p>
          <div class="form-dialog__actions">
            <button @click="goToForm()" class="form-dialog__btn">
              <svg width="15" height="15" fill="none" viewBox="0 0 24 24"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
              Remplir le formulaire
            </button>
          </div>
        </div>
      </Dialog>

    </div>

      <Dialog
        v-model:visible="showCodeByQuestionDialog"
        modal
        :showHeader="false"
        :style="{ width: '500px', maxWidth: '95vw' }"
        :breakpoints="{ '575px': '95vw' }"
      >
        <div class="form-dialog">
          <div class="form-dialog__icon" style="background:#eff6ff; color:#3b82f6;">
            <svg width="28" height="28" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/><path d="M12 8v4M12 16h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
          </div>
          <h3 class="form-dialog__title">Code de la route</h3>
          <p class="form-dialog__desc">
            Dans votre questionnaire vous aviez répondu <strong>Oui</strong> à la question <em>« Avez-vous votre code ? »</em><br><br>
            Voulez-vous changer cette réponse ? Si oui, vous aurez alors accès à la partie code de monpermis.fr.
          </p>
          <div class="form-dialog__actions" style="display:flex; gap:10px; justify-content:center;">
            <button @click="showCodeByQuestionDialog = false" class="cbq-btn cbq-btn--ghost">Retour</button>
            <button @click="confirmChangeCodeByQuestion" class="cbq-btn cbq-btn--primary">Oui, changer ma réponse</button>
          </div>
        </div>
      </Dialog>

  </div>

  <div class="home-mobile-eleve">
    <div class="head-mobile">
      <HeaderMobile page="MONPERMIS.FR" :user="this.$store.state.user.prenom" />
    </div>

      <h1>Bonjour {{this.$store.state.user.prenom}} !</h1>
      <p class="subtitle">Voici le suivi de votre permis de conduite</p>

    <div class="nav-content">
      <div class="nav-card pulse" v-if="this.dossier.contrat == false" @click="goToForm()">
        <div class="nav-logo">
          <svg width="40" height="40" fill="none" viewBox="0 0 24 24"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#3b82f6" stroke-width="1.5"/><path d="M8 12h8M8 8h5" stroke="#3b82f6" stroke-width="1.5" stroke-linecap="round"/></svg>
        </div>
        <div class="nav-info">
          <span class="title">FORMULAIRE</span><br>
        </div>
      </div>

      <div class="nav-card dossier" @click="goToDossier()">
        <div class="nav-logo amber-light">
          <svg width="30" height="30" fill="none" viewBox="0 0 24 24"><path d="M3 7a2 2 0 012-2h14a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V7z" stroke="#d97706" stroke-width="1.5"/><path d="M3 7l9 6 9-6" stroke="#d97706" stroke-width="1.5"/></svg>
        </div>
        <div class="nav-info">
          <span class="title">DOSSIER</span><br>
          <span
            v-if="
              this.$store.state.user.role.label == 'eleve'
            "
            class="nav-dossier"
            :class="dossier.neph ? 'text-green' : 'text-red'"
          >
            <template v-if="this.dossier !== null">
              {{ dossier.info }}
            </template>
          </span>
        </div>
      </div>

      <div class="nav-card code" @click="goToCode()">
        <div class="nav-logo blue-light">
          <svg width="40" height="40" fill="none" viewBox="0 0 24 24"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#3b82f6" stroke-width="1.5"/><path d="M8 12h8M8 8h5" stroke="#3b82f6" stroke-width="1.5" stroke-linecap="round"/></svg>
        </div>
        <div class="nav-info">
          <span class="title">CODE</span><br>
          <span class="nav-dossier">{{code.info}}</span>
        </div>
      </div>

      <div class="nav-card stagecode" v-if="showStageCodeButton" @click="goToStageCode()">
        <div class="nav-logo blue-light">
          <svg width="30" height="30" fill="none" viewBox="0 0 24 24"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#3b82f6" stroke-width="1.5"/><path d="M8 12h8M8 8h5" stroke="#3b82f6" stroke-width="1.5" stroke-linecap="round"/></svg>
        </div>
        <div class="nav-info">
          <span class="title">STAGE DE CODE</span><br>
        </div>
      </div>

      <div class="nav-card planning" @click="goToConduite()">
        <div class="nav-logo green-light">
          <svg width="30" height="30" fill="none" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2" stroke="#1a9e6e" stroke-width="1.5"/><path d="M3 10h18" stroke="#1a9e6e" stroke-width="1.5"/><path d="M8 4V2M16 4V2" stroke="#1a9e6e" stroke-width="1.5" stroke-linecap="round"/></svg>
        </div>
        <div class="nav-info">
          <span class="title">CONDUITE</span><br>
          <span class="nav-dossier">{{conduite.pourcent.status}}</span>
        </div>
      </div>

      <div class="nav-card edition" @click="openDevDialog('Edition de votre permis')">
        <div class="nav-logo red-light">
          <svg width="30" height="30" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="7" r="4" stroke="#f43f5e" stroke-width="1.5"/><path d="M6 21c0-3.314 2.686-6 6-6s6 2.686 6 6" stroke="#f43f5e" stroke-width="1.5" stroke-linecap="round"/></svg>
        </div>
        <div class="nav-info">
          <span class="title">EDITION DE PERMIS</span><br>
        </div>
      </div>

      <div class="nav-card pulse" v-if="this.lyceen == 'true'" @click="this.$router.push('/StageCode');">
        <div class="nav-logo">
          <img src="../../assets/images/event.png" alt="">
        </div>
        <div class="nav-info">
          <span class="title">EVENEMENT</span><br>
        </div>
      </div>

    </div>
  </div>

</template>
<script>
import { mapGetters } from "vuex";
import LoaderCar from "../LoaderCar.vue";

export default {

    props: ["dossierEleve"],

    components: {
      LoaderCar
    },

    computed: {
      ...mapGetters(["redirectDossierNeed"]),

      showStageCodeButton() {
        if (this.code.status === "REUSSI") return false;
        if (this.code.isLyceePartner) return true;
        return this.code.stageCodeAVenir === true;
      },
    },

    data() {
      return {
        showPopupForm: false,
        showCodeByQuestionDialog: false,
        showDevDialog: false,
        devFeatureLabel: "",
        // Bascule une carte du HomeEleve en mode "En développement" avec dialog d'info
        devDossier: false,
        devCode: false,
        devConduite: true,
        dossier: {
          status: "",
          neph: "",
          pourcent: 0,
          info: "",
          contrat: false
        },

        code: {
          date: "",
          pourcent: 0,
          score: "",
          status: "",
          info: "",
          codeByQuestion: false,
          isLyceePartner: false,
          stageCodeAVenir: false
        },

        conduite: {
          info: "",
          pourcent: 0,
          status: "EN COURS"
        },

        loading: true,
      }
    },

    mounted() {
        this.getHomeInfoEleve();
    },

    methods: {
        getHomeInfoEleve(){
            window.api
                .get("/eleve/home/info/" + this.$store.state.user.id, {
                headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                },
                })
                .then((response) => {
                    this.loading = false;
                    setTimeout(() => {
                      this.dossier.contrat = response.data.info.dossier.contrat;
                      this.dossier.neph = response.data.info.dossier.neph;
                      this.$store.commit("setNumNeph", response.data.info.dossier.neph ?? null);
                      if(response.data.info.dossier.status === "FORMULAIRE" || response.data.info.dossier.status === "Incomplet" && response.data.info.dossier.neph === null){
                        document.querySelector("div.bar-dossier").style.width = "0%";
                        document.querySelector("div.bar-dossier").classList.add("red");
                        document.querySelector("span.badge-dossier").classList.add("red");
                        this.dossier.status = response.data.info.dossier.status;
                        this.dossier.pourcent = "0 %";
                        if(response.data.info.dossier.status === "FORMULAIRE"){
                          this.dossier.info = "Veuillez remplir le formulaire";
                          document.querySelector("span.badge-code").classList.add("grey");
                          this.code.status = "FORMULAIRE";
                        }else{
                          this.dossier.info = "Envoyer vos pièces";
                        }
                        
                      }else if(response.data.info.dossier.status === "À traiter"){
                        document.querySelector("div.bar-dossier").style.width = "25%";
                        document.querySelector("div.bar-dossier").classList.add("red");
                        document.querySelector("span.badge-dossier").classList.add("red");
                        this.dossier.status = "EN ATTENTE";
                        this.dossier.pourcent = "25 %";
                        this.dossier.info = "Votre agence s'occupe de votre dossier";
                      }else if(response.data.info.dossier.status === "Validées"){
                        document.querySelector("div.bar-dossier").style.width = "50%";
                        document.querySelector("div.bar-dossier").classList.add("orange");
                        document.querySelector("span.badge-dossier").classList.add("orange");
                        this.dossier.status = "Validé";
                        this.dossier.pourcent = "50 %";
                        this.dossier.info = "Votre agence a validé les pièces de votre dossier";
                      }else if(response.data.info.dossier.status === "Saisi"){
                        document.querySelector("div.bar-dossier").style.width = "75%";
                        document.querySelector("div.bar-dossier").classList.add("orange");
                        document.querySelector("span.badge-dossier").classList.add("orange");
                        this.dossier.status = response.data.info.dossier.status;
                        this.dossier.pourcent = "75 %";
                        this.dossier.info = "Votre dossier a été transmis à la préfecture";
                      }else if(response.data.info.dossier.status === "Enregistrer" || response.data.info.dossier.neph !== null){
                        document.querySelector("div.bar-dossier").style.width = "100%";
                        document.querySelector("div.bar-dossier").classList.add("green");
                        document.querySelector("span.badge-dossier").classList.add("green");
                        this.dossier.status = response.data.info.dossier.status;
                        this.dossier.pourcent = "100 %";
                        this.dossier.info = "Votre numéro NEPH : " + response.data.info.dossier.neph;
                      }

                      this.code.codeByQuestion = response.data.info.code.codeByQuestion === true;
                      this.code.isLyceePartner = response.data.info.code.isLyceePartner === true;
                      this.code.stageCodeAVenir = response.data.info.code.stageCodeAVenir === true;

                      if(response.data.info.code.status === "EN ATTENTE"){
                        this.code.pourcent = response.data.info.code.pourcent + " %";
                        document.querySelector("span.badge-code").classList.add("grey");
                        this.code.status = response.data.info.code.status;
                        document.querySelector("div.bar-code").style.width = response.data.info.code.pourcent + "%";
                      }else if(response.data.info.code.status === "EN COURS"){
                        this.code.pourcent = response.data.info.code.pourcent + " %";
                        document.querySelector("span.badge-code").classList.add("orange");
                        this.code.status = response.data.info.code.status;
                        document.querySelector("div.bar-code").style.width = response.data.info.code.pourcent + "%";
                        document.querySelector("div.bar-code").classList.add("orange");

                        if(response.data.info.code.date !== null){
                          this.code.info = "Examen programmé le : " + response.data.info.code.date;
                        }

                      }else if(response.data.info.code.status === "ECHEC"){
                        this.code.pourcent = response.data.info.code.pourcent + " %";
                        document.querySelector("span.badge-code").classList.add("red");
                        this.code.status = response.data.info.code.status;
                        document.querySelector("div.bar-code").style.width = response.data.info.code.pourcent + "%";
                        document.querySelector("div.bar-code").classList.add("orange");
                        this.code.info = "Echec de votre examen programmé le : " + response.data.info.code.date + " vous avez eu " + response.data.info.code.score + "/40";
                      }else if(response.data.info.code.status === "REUSSI"){
                        this.code.pourcent = response.data.info.code.pourcent + " %";
                        document.querySelector("span.badge-code").classList.add("green");
                        this.code.status = response.data.info.code.status;
                        document.querySelector("div.bar-code").style.width = response.data.info.code.pourcent + "%";
                        document.querySelector("div.bar-code").classList.add("green");
                        if(response.data.info.code.codeBefore === false){
                          this.code.info = "Réussite de votre examen programmé le : " + response.data.info.code.date + " vous avez eu " + response.data.info.code.score + "/40";
                        }else{
                          this.code.info = "Félicitations pour votre code de la route !";
                        }
                        
                      }

                      if(response.data.info.conduite.niveau < 25){
                        document.querySelector("div.bar-conduite").style.width = response.data.info.conduite.niveau + "%";
                        document.querySelector("div.bar-conduite").classList.add("red");
                      }else if(response.data.info.conduite.niveau  < 50){
                        document.querySelector("div.bar-conduite").style.width = response.data.info.conduite.niveau + "%";
                        document.querySelector("div.bar-conduite").classList.add("orange");
                      }else if(response.data.info.conduite.niveau  !== 100){
                        document.querySelector("div.bar-conduite").style.width = response.data.info.conduite.niveau + "%";
                        document.querySelector("div.bar-conduite").classList.add("orange");
                      }else if(response.data.info.conduite.niveau  === 100){
                        document.querySelector("div.bar-conduite").style.width = response.data.info.conduite.niveau + "%";
                        document.querySelector("div.bar-conduite").classList.add("green");
                      }

                      if(response.data.info.conduite.status === "EN COURS"){
                        document.querySelector("span.badge-conduite").classList.add("orange");
                        this.conduite.status = "EN COURS";
                      }else if(response.data.info.conduite.status === "REUSSI"){
                        document.querySelector("span.badge-conduite").classList.add("green");
                        this.conduite.status = "REUSSI";
                      }else{
                        document.querySelector("span.badge-conduite").classList.add("green");
                        this.conduite.status = response.data.info.conduite.status;
                      }

                      this.conduite.pourcent = response.data.info.conduite;
                    }, 1);


                })
                .catch((error) => {
                console.log(error);
                });
        },

        goToDossier() {
          if (this.devDossier) {
            this.openDevDialog("Dossier");
            return;
          }
          if (this.$store.state.user.role.label !== "eleve") return;
          if( this.dossier.status === 'Enregistrer') return;
          if( this.dossier.neph !== null && this.dossier.neph !== '') return;

          // Pas de contrat → formulaire
          
          if (this.dossier.contrat == false) {
            this.showPopupForm = true;
            return;
          }

          window.api
            .get("/student/" + this.$store.state.user.id + "/paiement/dossier", {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then((response) => {
              if (!response.data.paid) {
                this.$router.push({ name: "Dossier-paiement" });
              } else {
                if (this.dossierEleve === null || this.dossierEleve.numNeph === "" || this.dossierEleve.numNeph === null) {
                  this.$router.push({ name: "Piece" });
                } else {
                  this.$router.push({ name: "Piece" });
                }
              }
            })
            .catch((error) => {
              console.log(error?.response?.data?.message ?? error.message);
              this.showPopupForm = true;
            });
        },

        goToForm() {
          this.$router.push({
            name: "Dossier",
            params: { personalData: "true" },
          });
        },

        goToCode() {
          if (this.devCode) {
            this.openDevDialog("Code");
            return;
          }
          if (this.$store.state.user.role.label !== "eleve") return;

          if (this.dossier.contrat == false) {
            this.showPopupForm = true;
            return;
          }

          if (this.code.codeByQuestion === true) {
            this.showCodeByQuestionDialog = true;
            return;
          }

          if (this.redirectDossierNeed) {
            this.$store.state.displayRedirectDossier = true;
          } else {
            this.$router.push({ name: "CodeFront" });
          }
        },

        confirmChangeCodeByQuestion() {
          window.api
            .patch("/eleve/" + this.$store.state.user.id + "/contract/reset-code", {}, {
              headers: { Authorization: "Bearer " + this.$store.state.token },
            })
            .then(() => {
              this.code.codeByQuestion = false;
              this.showCodeByQuestionDialog = false;
              this.$router.push({ name: "CodeFront" });
            })
            .catch((error) => {
              console.log(error);
            });
        },

        openDevDialog(label) {
          this.devFeatureLabel = label;
          this.showDevDialog = true;
        },

        async goToStageCode() {
          try {
            const [dossierRes, codeRes] = await Promise.all([
              window.api.get("/student/" + this.$store.state.user.id + "/paiement/dossier", {
                headers: { Authorization: "Bearer " + this.$store.state.token },
              }),
              window.api.get("/student/" + this.$store.state.user.id + "/paiement/code", {
                headers: { Authorization: "Bearer " + this.$store.state.token },
              }),
            ]);

            if (dossierRes.data.paid !== true || codeRes.data.paid !== true) {
              alert("Pour réserver une place au stage de code, vous devez au préalable régler les prestations DOSSIER et CODE");
              return;
            }

            this.$router.push({ name: "StageCode" });
          } catch (error) {
            console.log(error);
          }
        },

        goToConduite() {
          if (this.devConduite) {
            this.openDevDialog("Conduite");
            return;
          }
          if (this.$store.state.user.role.label === "eleve") {
            if( this.dossier.contrat == false && this.$store.state.user.role.label === "eleve"){
              this.showPopupForm = true;
            }else{
              this.$router.push({ name: "eleve_conduite" });
            }
          }
        },

    },

};
</script>
<style scoped>

div.formBtn{
  margin-top: 1rem;
}

div.home-mobile-eleve{
  display: none;
}

p#txtForm{
  color: #313133;
  text-align: center;
  padding: 0 10px;
  font-size: 1.2rem;
}

.buttonShin {
  min-width: 250px;
  min-height: 60px;
  font-family: "Nunito", sans-serif;
  font-size: 22px;
  text-transform: uppercase;
  letter-spacing: 1.3px;
  font-weight: 700;
  color: #FFFFFF;
  background: #3a86ff;

  border: none;
  border-radius: 1000px;

  transition: all 0.3s ease-in-out 0s;
  cursor: pointer;
  outline: none;
  position: relative;
  padding: 10px;
}

button.buttonShin::before {
  content: "";
  border-radius: 1000px;
  min-width: calc(250px + 12px);
  min-height: calc(60px + 12px);
  border: 6px solid #5093FF;
  box-shadow: 0 0 60px #5093FF;
  position: absolute;
  animation: ring 4s infinite;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: all 0.3s ease-in-out 0s;
}

.buttonShin:hover,
.buttonShin:focus {
  color: #313133;
  transform: translateY(-6px);
}

button.buttonShin:hover::before,
button.buttonShin:focus::before {
  opacity: 1;
}

button.buttonShin::after {
  content: "";
  width: 30px;
  height: 30px;
  border-radius: 100%;
  border: 6px solid #3a86ff;
  position: absolute;
  z-index: -1;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

button.buttonShin:hover::after,
button.buttonShin:focus::after {
  animation: none;
  display: none;
}

@keyframes ring {
  0% {
    width: 30px;
    height: 30px;
    opacity: 1;
  }

  100% {
    width: 100px;
    height: 100px;
    opacity: 0;
  }
}

.home-eleve {
  width: 60%;
  text-align: left;
  margin: auto;
  margin-top: 4rem;
}

h1 {
  margin-bottom: 5px;
  font-weight: bold;
}

.subtitle {
  color: #777;
  margin-bottom: 30px;
}

.greeting-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.btn-stagecode {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #3b82f6;
  color: #ffffff;
  border: none;
  border-radius: 12px;
  padding: 14px 26px;
  font-weight: 700;
  font-size: 15px;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.35);
  transition: background 0.18s, transform 0.1s;
}

.btn-stagecode::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: calc(100% + 12px);
  min-height: calc(100% + 12px);
  border-radius: 18px;
  border: 4px solid #5093ff;
  box-shadow: 0 0 30px #5093ff;
  animation: stagecodeRing 3s infinite;
  pointer-events: none;
}

.btn-stagecode:hover,
.btn-stagecode:focus {
  background-color: #2563eb;
  transform: translateY(-2px);
}

.btn-stagecode:active {
  transform: scale(0.97);
}

@keyframes stagecodeRing {
  0% {
    width: 30px;
    height: 30px;
    opacity: 1;
  }

  100% {
    width: 90px;
    height: 55px;
    opacity: 0;
  }
}

.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.card {
  background-color: white;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 30px;
  width: 100%;
  cursor: pointer;
}

.card:hover{
  transform: translateY(-3px); 
  box-shadow: 0 12px 32px rgba(0,0,0,.07);
  border-top: 4px solid #1d4ed8;
}

.card-header-eleve {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  font-weight: bold;
  background-color: white;
}

.badge {
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 12px;
  color: #fff;
}

.red {
  background: #f42a2a;
}

.orange {
  background: #f4a62a;
}
.green {
  background: #2e9e59;
}
.grey {
  background: #bbb;
}

.progress {
  height: 8px;
  background: #e0e0e0;
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 10px;
}

.progress-bar {
  height: 100%;
  border-radius: 5px;
}

.progress-bar.orange {
  background: #f4a62a;
}
.progress-bar.green {
  background: #2e9e59;
}
.progress-bar.grey {
  background: #bbb;
}

.card-footer-eleve span.text-red {
  color: #f42a2a;
}
.card-footer-eleve span.text-green {
  color: #2e9e59;
}

.card-footer-eleve {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #666;
  margin-bottom: 10px;
  background-color: white;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e2e8f0;
}

.small {
  font-size: 12px;
  color: #888;
  margin-bottom: 10px;
}

p.link {
  display: block;
  text-align: center;
  color: #4a90e2;
  text-decoration: none;
  font-size: 14px;
  cursor: pointer;
  margin-top: 1rem;
}

p.link:hover {
  text-decoration: underline;
}

@media (max-width: 1000px){
  div.home-desktop-eleve{
    display: none;
  }

  div.home-mobile-eleve{
    display: block;
    width: 100%;
    height: 100vh;
  }

  div.home-mobile-eleve div.head-mobile{
    display: block;
    width: 100%;
    height: 5vh;

  }

  div.home-mobile-eleve div.nav-content{
    height: 95vh;
    margin-top: 3rem;
  }

  div.home-mobile-eleve div.nav-content div.nav-card{
    border: 1px solid #D2D9E0;
    border-radius: 10px;
    background-color: white;
    padding: 1rem;
    width: 90%;
    margin: auto;
    margin-bottom: 2rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-image: url("../../assets/images/fond2.png");
    background-size: cover;
    position: relative;
  }

  div.home-mobile-eleve div.nav-content div.nav-card::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 3px;
    border-radius: 16px 0 0 16px;
    background: #2563eb;
  }

  div.home-mobile-eleve div.nav-content div.nav-card.code::before {
    background: #2563eb;
  }
  div.home-mobile-eleve div.nav-content div.nav-card.stagecode::before {
    background: #2563eb;
  }
  div.home-mobile-eleve div.nav-content div.nav-card.dossier::before {
    background: #d97706;
  }
  div.home-mobile-eleve div.nav-content div.nav-card.planning::before {
    background: #16a34a;
  }
  div.home-mobile-eleve div.nav-content div.nav-card.edition::before {
    background: #f43f5e;
  }

  @keyframes pulseAnim {
    0% {
      transform: scale(1);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
    50% {
      transform: scale(1.01);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
    }
    100% {
      transform: scale(1);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
  }

  /* Activation uniquement si classe pulse */
  div.home-mobile-eleve div.nav-content div.nav-card.pulse {
    animation: pulseAnim 1.5s ease-in-out infinite;
  }

  div.home-mobile-eleve div.nav-content div.nav-card div.nav-logo{
    width: 50px; 
    height: 50px; 
    border-radius: 12px; 
    display: flex; 
    align-items: center; 
    justify-content: center; 
  }

  .amber-light{
      background-color: #fef3c7;
  }

  .amber-dark{
      color: #b45309;
  }

  .blue-light{
      background-color: #eff6ff;
  }

  .blue-dark{
      color: #1d4ed8;
  }

  .green-light{
      background-color: #e8f7f1;
  }

  .green-dark{
      color: #1a9e6e;
  }

  .red-light{
      background-color: #fff1f2;
  }

  .red-dark{
      color: #be123c;
  }

  div.home-mobile-eleve div.nav-content div.nav-card div.nav-logo img{
    width: 60px;
    height: 60px;
  }

  div.home-mobile-eleve div.nav-content div.nav-card div.nav-info{
    text-align: right;
  }

  div.home-mobile-eleve div.nav-content div.nav-card div.nav-info span.title{
    font-weight: bold;
    font-size: 20px;
    color: black;
  }

  div.home-mobile-eleve div.nav-content div.nav-card div.nav-info span.nav-dossier{
    color: rgb(148, 148, 148);
  }

  div.home-mobile-eleve div.nav-content div.nav-card div.nav-info span.nav-dossier.text-red{
    color: #f42a2a;
  }

  div.home-mobile-eleve div.nav-content div.nav-card div.nav-info span.nav-dossier.text-green{
    color: #2e9e59;
  }

  div.formulaire{
    display: none;
  }

}

/* ── Dialog formulaire dossier ── */
.form-dialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 32px 24px 24px;
  gap: 12px;
}

.form-dialog__icon {
  width: 56px;
  height: 56px;
  background: #eff6ff;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3b82f6;
  flex-shrink: 0;
}

.form-dialog__title {
  font-size: 18px;
  font-weight: 700;
  color: #1a1f2e;
  margin: 4px 0 0;
}

.form-dialog__desc {
  font-size: 14px;
  color: #64748b;
  line-height: 1.6;
  max-width: 340px;
  margin: 0;
}

.form-dialog__actions {
  margin-top: 8px;
}

.form-dialog__btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  background: #3b82f6;
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: background .15s, transform .15s, box-shadow .15s;
}

.form-dialog__btn:hover {
  background: #2563eb;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, .3);
}

.cbq-btn {
  display: inline-flex;
  align-items: center;
  padding: 9px 20px;
  border-radius: 8px;
  border: none;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  font-family: inherit;
}
.cbq-btn--ghost {
  background: transparent;
  border: 1px solid #e2e8f0;
  color: #64748b;
}
.cbq-btn--ghost:hover { background: #f8fafc; }
.cbq-btn--primary {
  background: #3b82f6;
  color: #fff;
}
.cbq-btn--primary:hover { background: #2563eb; }
</style>
